export const ORGANIZATION_CREDITS = {
  total: 0,
  allocated: 0,
  remaining: 0,
  name: "",
};

export const ROLE_CONFIG = {
  teacher: {
    label: "Teacher",
    color: "hsl(217, 91%, 60%)",
    bgClass: "bg-blue-50 border-blue-200",
    textClass: "text-blue-700",
  },
  student: {
    label: "Student",
    color: "hsl(142, 71%, 45%)",
    bgClass: "bg-emerald-50 border-emerald-200",
    textClass: "text-emerald-700",
  },
  admin: {
    label: "Admin",
    color: "hsl(25, 95%, 53%)",
    bgClass: "bg-orange-50 border-orange-200",
    textClass: "text-orange-700",
  },
  administrative: {
    label: "Admin Staff",
    color: "hsl(262, 83%, 58%)",
    bgClass: "bg-violet-50 border-violet-200",
    textClass: "text-violet-700",
  },
};

export const SAMPLE_USERS = [
  // {
  //   id: "698da313b611b501f30c3c52",
  //   name: "Mauro D'Aloisio",
  //   email: "mauro.daloisio@gmail.com",
  //   role: "student",
  //   allocated: 1500,
  //   used: 800,
  //   remaining: 700,
  //   usageHistory: [
  //     {
  //       id: "h1",
  //       date: "2026-02-10",
  //       action: "Contratto operatore economico",
  //       creditsUsed: 200,
  //       description: "Generated Contratto operatore economico document.",
  //     },
  //     {
  //       id: "h2",
  //       date: "2026-02-08",
  //       action: "Aggiudicazione appalto",
  //       creditsUsed: 300,
  //       description:
  //         "Processed Aggiudicazione appalto task for school records.",
  //     },
  //     {
  //       id: "h3",
  //       date: "2026-02-05",
  //       action: "Determina ricorso appalto",
  //       creditsUsed: 300,
  //       description:
  //         "Completed Determina ricorso appalto for administrative purposes.",
  //     },
  //   ],
  // },
  // {
  //   id: "u2",
  //   name: "Giulia Rossi",
  //   email: "giulia.rossi@school.edu",
  //   role: "teacher",
  //   allocated: 5000,
  //   used: 4100,
  //   remaining: 900,
  //   usageHistory: [
  //     {
  //       id: "h4",
  //       date: "2026-02-11",
  //       action: "Prestazione occasionale",
  //       creditsUsed: 500,
  //       description:
  //         "Recorded Prestazione occasionale for temporary teaching task.",
  //     },
  //     {
  //       id: "h5",
  //       date: "2026-02-09",
  //       action: "Determina incarico interna",
  //       creditsUsed: 300,
  //       description: "Completed Determina incarico interna assignment.",
  //     },
  //     {
  //       id: "h6",
  //       date: "2026-02-06",
  //       action: "Nomina commissione",
  //       creditsUsed: 300,
  //       description: "Executed Nomina commissione for school committee.",
  //     },
  //   ],
  // },
  // {
  //   id: "u3",
  //   name: "Lorenzo Bianchi",
  //   email: "lorenzo.bianchi@school.edu",
  //   role: "student",
  //   allocated: 1500,
  //   used: 800,
  //   remaining: 700,
  //   usageHistory: [
  //     {
  //       id: "h7",
  //       date: "2026-02-10",
  //       action: "Determina incarico individuale",
  //       creditsUsed: 200,
  //       description: "Assigned Determina incarico individuale task.",
  //     },
  //     {
  //       id: "h8",
  //       date: "2026-02-07",
  //       action: "Interrogazione procedure e policy",
  //       creditsUsed: 350,
  //       description:
  //         "Reviewed Interrogazione procedure e policy of the institute.",
  //     },
  //     {
  //       id: "h9",
  //       date: "2026-02-03",
  //       action: "AI per la didattica",
  //       creditsUsed: 250,
  //       description: "Utilized AI per la didattica for lesson support.",
  //     },
  //   ],
  // },
  // {
  //   id: "u4",
  //   name: "Martina Verdi",
  //   email: "martina.verdi@school.edu",
  //   role: "student",
  //   allocated: 1500,
  //   used: 1400,
  //   remaining: 100,
  //   usageHistory: [
  //     {
  //       id: "h10",
  //       date: "2026-02-11",
  //       action: "Plan your lesson",
  //       creditsUsed: 400,
  //       description: "Created lesson outline using Plan your lesson template.",
  //     },
  //     {
  //       id: "h11",
  //       date: "2026-02-09",
  //       action: "Strike Notification",
  //       creditsUsed: 500,
  //       description: "Issued Strike Notification to students and families.",
  //     },
  //     {
  //       id: "h12",
  //       date: "2026-02-05",
  //       action: "Parent-Teacher Meeting Notification",
  //       creditsUsed: 300,
  //       description: "Sent Parent-Teacher Meeting Notification to parents.",
  //     },
  //   ],
  // },
  // {
  //   id: "u5",
  //   name: "Federico Russo",
  //   email: "federico.russo@school.edu",
  //   role: "admin",
  //   allocated: 3000,
  //   used: 1200,
  //   remaining: 1800,
  //   usageHistory: [
  //     {
  //       id: "h13",
  //       date: "2026-02-10",
  //       action: "Extracurricular Activity Notification",
  //       creditsUsed: 600,
  //       description: "Scheduled Extracurricular Activity Notification.",
  //     },
  //     {
  //       id: "h14",
  //       date: "2026-02-04",
  //       action: "Playground",
  //       creditsUsed: 400,
  //       description: "Facilitated Playground activity discussions.",
  //     },
  //     {
  //       id: "h15",
  //       date: "2026-01-29",
  //       action: "Contratto operatore economico",
  //       creditsUsed: 200,
  //       description: "Generated Contratto operatore economico document.",
  //     },
  //   ],
  // },
  // {
  //   id: "u6",
  //   name: "Chiara Fontana",
  //   email: "chiara.fontana@school.edu",
  //   role: "staff",
  //   allocated: 2000,
  //   used: 950,
  //   remaining: 1050,
  //   usageHistory: [
  //     {
  //       id: "h16",
  //       date: "2026-02-09",
  //       action: "Aggiudicazione appalto",
  //       creditsUsed: 300,
  //       description: "Processed Aggiudicazione appalto task.",
  //     },
  //     {
  //       id: "h17",
  //       date: "2026-02-03",
  //       action: "Determina ricorso appalto",
  //       creditsUsed: 350,
  //       description: "Completed Determina ricorso appalto assignment.",
  //     },
  //     {
  //       id: "h18",
  //       date: "2026-01-28",
  //       action: "Prestazione occasionale",
  //       creditsUsed: 300,
  //       description: "Recorded Prestazione occasionale for temporary tasks.",
  //     },
  //   ],
  // },
  // {
  //   id: "u7",
  //   name: "Giorgio Conti",
  //   email: "giorgio.conti@school.edu",
  //   role: "teacher",
  //   allocated: 5000,
  //   used: 2700,
  //   remaining: 2300,
  //   usageHistory: [
  //     {
  //       id: "h19",
  //       date: "2026-02-11",
  //       action: "Determina incarico altra scuola",
  //       creditsUsed: 400,
  //       description: "Assigned Determina incarico altra scuola task.",
  //     },
  //     {
  //       id: "h20",
  //       date: "2026-02-07",
  //       action: "Determina incarico interno",
  //       creditsUsed: 700,
  //       description: "Completed Determina incarico interno task.",
  //     },
  //     {
  //       id: "h21",
  //       date: "2026-02-02",
  //       action: "Nomina commissione",
  //       creditsUsed: 500,
  //       description: "Executed Nomina commissione for school committee.",
  //     },
  //   ],
  // },
  // {
  //   id: "u8",
  //   name: "Sara Esposito",
  //   email: "sara.esposito@school.edu",
  //   role: "student",
  //   allocated: 1500,
  //   used: 450,
  //   remaining: 1050,
  //   usageHistory: [
  //     {
  //       id: "h22",
  //       date: "2026-02-08",
  //       action: "Determina avviso selezione",
  //       creditsUsed: 250,
  //       description: "Issued Determina avviso selezione notice.",
  //     },
  //     {
  //       id: "h23",
  //       date: "2026-02-02",
  //       action: "Determina incarico individuale",
  //       creditsUsed: 200,
  //       description: "Completed Determina incarico individuale assignment.",
  //     },
  //     {
  //       id: "h24",
  //       date: "2026-01-29",
  //       action: "Interrogazione procedure e policy",
  //       creditsUsed: 300,
  //       description: "Reviewed Interrogazione procedure e policy of institute.",
  //     },
  //   ],
  // },
  // {
  //   id: "u9",
  //   name: "Alessandro Greco",
  //   email: "alessandro.greco@school.edu",
  //   role: "student",
  //   allocated: 1500,
  //   used: 1100,
  //   remaining: 400,
  //   usageHistory: [
  //     {
  //       id: "h25",
  //       date: "2026-02-10",
  //       action: "AI per la didattica",
  //       creditsUsed: 400,
  //       description: "Applied AI per la didattica in lesson planning.",
  //     },
  //     {
  //       id: "h26",
  //       date: "2026-02-06",
  //       action: "Plan your lesson",
  //       creditsUsed: 350,
  //       description: "Created detailed lesson plan.",
  //     },
  //     {
  //       id: "h27",
  //       date: "2026-02-01",
  //       action: "Strike Notification",
  //       creditsUsed: 350,
  //       description: "Sent Strike Notification to families.",
  //     },
  //   ],
  // },
  // {
  //   id: "u10",
  //   name: "Elena Romano",
  //   email: "elena.romano@school.edu",
  //   role: "staff",
  //   allocated: 2000,
  //   used: 1600,
  //   remaining: 400,
  //   usageHistory: [
  //     {
  //       id: "h28",
  //       date: "2026-02-11",
  //       action: "Parent-Teacher Meeting Notification",
  //       creditsUsed: 500,
  //       description: "Sent Parent-Teacher Meeting Notification to parents.",
  //     },
  //     {
  //       id: "h29",
  //       date: "2026-02-07",
  //       action: "Extracurricular Activity Notification",
  //       creditsUsed: 400,
  //       description: "Scheduled Extracurricular Activity Notification.",
  //     },
  //     {
  //       id: "h30",
  //       date: "2026-02-03",
  //       action: "Playground",
  //       creditsUsed: 350,
  //       description: "Facilitated Playground activity.",
  //     },
  //   ],
  // },
];

// export const ROLE_ALLOCATIONS = [
//   {
//     role: "teacher",
//     label: "Teacher",
//     creditsPerUser: 5000,
//     userCount: 3,
//     totalAllocated: 15000,
//   },
//   {
//     role: "student",
//     label: "Student",
//     creditsPerUser: 1500,
//     userCount: 4,
//     totalAllocated: 6000,
//   },
//   {
//     role: "admin",
//     label: "Admin",
//     creditsPerUser: 3000,
//     userCount: 1,
//     totalAllocated: 3000,
//   },
//   {
//     role: "staff",
//     label: "Staff",
//     creditsPerUser: 2000,
//     userCount: 2,
//     totalAllocated: 4000,
//   },
// ];
